/**
 * A collection of utilities to help connect to the platform
 */
import ClientContext from "common/utils/client-context/ClientContext";

/**
 * Creates the limitless public API URL based on environment variables.
 *
 * @param {string} path
 */
const createPublicUrl = path => {
  const publicUrl = `${process.env.REACT_APP_BASE_PLATFORM_URL}community/${path}`;
  return encodeURI(publicUrl);
};
/**
 * Creates the limitless public API URL based on environment variables.
 *
 * @param {string} path
 */
const createIntegrationUrl = path => {
  const integrationUrl = `${process.env.REACT_APP_BASE_PLATFORM_URL}${process.env.REACT_APP_STAGE}/integration/${path}`;
  return encodeURI(integrationUrl);
};
/**
 * Creates the headers needed for a mution AJAX call (POST/PUT)
 *
 * @param {string} additionalParams
 * @param {string} additionalHeaders
 */
const createPublicHeaders = (additionalParams = {}, additionalHeaders = {}) => {
  return {
    headers: {
      "x-api-key": ClientContext._apiKey,
      ...additionalHeaders
    },
    timeout: parseInt(process.env.REACT_APP_HTTP_POST_TIMEOUT),
    params: {
      ...additionalParams
    }
  };
};
export const createPublicAPIRequest = (method, urlPath, queryParams, data, headers, isIntegration = false) => {
  return {
    method,
    url: isIntegration ? createIntegrationUrl(urlPath) : createPublicUrl(urlPath),
    ...createPublicHeaders(queryParams, headers),
    data
  };
};